import { Loadable } from '../../components/common/loadable/loadable';

export const ReplicationsLazyLoadContainer = Loadable<any>({
  loader: () =>
    import(
      /* webpackChunkName: "replications" */ './replications.container'
    ).then((module) => module.ReplicationsContainer),
});
